export const state = () => ({
	current_tab: 'about',
	initial_setup: false,
	cv_review: null,
});

export const mutations = {
	setCurrentTab(state: any, payload: any) {
		state.current_tab = payload;
	},
	setInitialSetup(state: any, payload: any) {
		state.initial_setup = payload;
	},
	setCvReview(state: any, payload: any) {
		state.cv_review = payload;
	},
};

export const getters = {
	getCurrentTab: (state: any) => state.current_tab,
	getInitialSetup: (state: any) => state.initial_setup,
	getCvReview: (state: any) => state.cv_review,
};

export const actions = {
	setCurrentTab(state: any, payload: any) {
		state.commit('setCurrentTab', payload);
	},
	updateInitialSetup(state: any, payload: any) {
		state.commit('setInitialSetup', payload);
	},

	setCvReview(state: any, payload: any) {
		state.commit('setCvReview', payload);
	},

	async getTemplate(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/template', { params: payload })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	fetchCvReview(state: any, payload: any){
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/cv-review')
				.then((res) => {
					state.dispatch('setCvReview', res.data !== '' ? res.data : null);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
};
